import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { PrimaryButton } from '@fluentui/react/lib/Button';
interface Props {
  title: string;
  subText: string;
  onClose: (confirmed: boolean) => void;
}

export default (props: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        type: DialogType.normal,
        title: props.title,
        closeButtonAriaLabel: 'Close',
        subText: props.subText,
      }}
      modalProps={{
        isBlocking: false,
        styles: { main: { maxWidth: 450 } },
      }}
      onDismiss={() => props.onClose(false)}
    >
      <DialogFooter>
        <PrimaryButton text={ t('Ok')} onClick={() => props.onClose(true)} />
      </DialogFooter>
    </Dialog>
  );
};
